<nav #header class="fixed-top headerStyle"
    style="background-color: white !important;filter: drop-shadow(1px 1px 1px #6666664d);"
    [ngClass]="{'navbar2': this.companyParamsService.getFadeMenu()}">
    <div class="green">
        <div class="mobile">
            <div style="width:80vw; text-align: center;padding-top: 20px;">
                <a href="https://volcanicparadisegalapagos.com/site/" target="_blank">
                    <img class="logo" src="../assets/images/logos-header/vp.svg" />
                </a>
            </div>
            <div class="contactDiv">
                <a href="https://wa.me/593989926995" target="_blank"><i class="fa fa-whatsapp fa-3"></i>
                    +593 98 992 6995</a>
            </div>
            <div class="contactDiv">
                <a href="mailto:info&#64;volcanicparadisegalapagos.com"><i class="fa fa-envelope-o fa-3"></i>
                    info&#64;volcanicparadisegalapagos.com</a>
            </div>
            <div class="social-icons">
                <a href="https://www.facebook.com/volcanicparadisegalapagos/" target="_blank"><i
                        class="fa fa-facebook"></i></a>
                <a href="https://twitter.com/VP_Galapagos" target="_blank"><i class="fa fa-twitter"></i></a>
                <a href="https://www.youtube.com/@volcanicparadisegalapagos383" target="_blank"><i
                        class="fa fa-youtube-play"></i></a>
                <a href="https://www.instagram.com/volcanicparadisegalapagos/" target="_blank"><i
                        class="fa fa-instagram"></i></a>
                <a href="https://www.tiktok.com/@volcanic.paradise" target="_blank"><i class="fa fa-tumblr"></i></a>
            </div>
            <div class="contactContainer">
                <div class="flags">
                    <a href="https://volcanicparadisegalapagos.com/site/" target="_blank"><img
                            src="../../../../../../../../assets/images/zh-TW.png"></a>
                    <a href="https://volcanicparadisegalapagos.com/site/" target="_blank"><img
                            src="../../../../../../../../assets/images/en-us.png"></a>
                    <a href="https://volcanicparadisegalapagos.com/site/" target="_blank"><img
                            src="../../../../../../../../assets/images/fr.png"></a>
                    <a href="https://volcanicparadisegalapagos.com/site/" target="_blank"><img
                            src="../../../../../../../../assets/images/de.png"></a>
                    <a href="https://volcanicparadisegalapagos.com/site/" target="_blank"><img
                            src="../../../../../../../../assets/images/ru.png"></a>
                    <a href="https://volcanicparadisegalapagos.com/site/" target="_blank"><img
                            src="../../../../../../../../assets/images/es-co.png"></a>
                </div>
                <ul class="navbar-nav contact">
                    <select style="width: 80vw; padding: 5px;">
                        <option>English</option>
                    </select>
                </ul>
            </div>
            <div class="menuButton">
                <a (click)="renderMenu()" href="javascript:void()"><i class="fa fa-bars"></i></a>
            </div>
            <div #header1 class="containerHeader container" [ngClass]="showMenu ? 'showMenu':''">
                <ul class="navbar-nav" [ngClass]="showMenu ? 'menu-backcolor':''" style="padding: 10px;">
                    <li class="nav-item menuItem"><a href="https://volcanicparadisegalapagos.com/site/"
                            target="_blank">HOME</a>
                    </li>
                    <li class="nav-item menuItem"><a href="https://volcanicparadisegalapagos.com/site/about-us/"
                            target="_blank">ABOUT US</a></li>
                    <li class="nav-item menuItem"><a href="https://volcanicparadisegalapagos.com/site/cruises/"
                            target="_blank">CRUISES</a></li>
                    <li class="nav-item menuItem"><a href="https://volcanicparadisegalapagos.com/site/land-based-trips/"
                            target="_blank">LAND BASED TRIPS</a></li>
                    <li class="nav-item menuItem"><a href="https://volcanicparadisegalapagos.com/site/day-trips/"
                            target="_blank">DAY
                            TRIPS</a>
                    </li>
                    <li class="nav-item menuItem"><a href="https://volcanicparadisegalapagos.com/site/diving/"
                            target="_blank">DIVING</a>
                    </li>
                    <li class="nav-item menuItem"><a href="https://volcanicparadisegalapagos.com/site/hotels/"
                            target="_blank">HOTELS</a>
                    <li class="nav-item menuItem"><a href="https://volcanicparadisegalapagos.com/site/contact-us/"
                            target="_blank">CONTACT
                            US</a>
                </ul>
                <div *ngIf="companyParamsService.getFiltersInterest()" class="wishlist tooltip-container">
                    <app-heart-header></app-heart-header>
                </div>
            </div>
        </div>
        <table style="width: 100%; border: none;" class="desktop">
            <tr>
                <td rowspan="2" style="width: 18%;text-align: center;vertical-align: middle;">
                    <div class="logo-desktop">
                        <a href="https://volcanicparadisegalapagos.com/site/" target="_blank">
                            <img class="logo" src="../assets/images/logos-header/vp.png" />
                        </a>
                    </div>
                </td>
                <td style="padding: 20px 1.5vw;">
                    <div class="containerMenu navbar-collapse collapse">
                        <div class="call-container">
                            <div class="contactDiv">
                                <a href="https://wa.me/593989926995" target="_blank"><i class="fa fa-whatsapp fa-3"></i>
                                    +593 98 992 6995</a>
                            </div>
                            <div class="contactDiv">
                                <a href="mailto:info&#64;volcanicparadisegalapagos.com"><i
                                        class="fa fa-envelope-o fa-3"></i>
                                    info&#64;volcanicparadisegalapagos.com</a>
                            </div>
                            <div class="social-icons">
                                <a href="https://www.facebook.com/volcanicparadisegalapagos/" target="_blank"><i
                                        class="fa fa-facebook"></i></a>
                                <a href="https://twitter.com/VP_Galapagos" target="_blank"><i
                                        class="fa fa-twitter"></i></a>
                                <a href="https://www.youtube.com/@volcanicparadisegalapagos383" target="_blank"><i
                                        class="fa fa-youtube-play"></i></a>
                                <a href="https://www.instagram.com/volcanicparadisegalapagos/" target="_blank"><i
                                        class="fa fa-instagram"></i></a>
                                <a href="https://www.tiktok.com/@volcanic.paradise" target="_blank"><i
                                        class="fa fa-tumblr"></i></a>
                            </div>
                            <div class="contactContainer">
                                <div class="flags">
                                    <a href="https://volcanicparadisegalapagos.com/site/" target="_blank"><img
                                            src="../../../../../../../../assets/images/zh-TW.png"></a>
                                    <a href="https://volcanicparadisegalapagos.com/site/" target="_blank"><img
                                            src="../../../../../../../../assets/images/en-us.png"></a>
                                    <a href="https://volcanicparadisegalapagos.com/site/" target="_blank"><img
                                            src="../../../../../../../../assets/images/fr.png"></a>
                                    <a href="https://volcanicparadisegalapagos.com/site/" target="_blank"><img
                                            src="../../../../../../../../assets/images/de.png"></a>
                                    <a href="https://volcanicparadisegalapagos.com/site/" target="_blank"><img
                                            src="../../../../../../../../assets/images/ru.png"></a>
                                    <a href="https://volcanicparadisegalapagos.com/site/" target="_blank"><img
                                            src="../../../../../../../../assets/images/es-co.png"></a>
                                </div>
                                <ul class="navbar-nav contact">
                                    <select style="width: 13vw; padding: 5px;">
                                        <option>English</option>
                                    </select>
                                </ul>
                            </div>
                        </div>
                    </div>
                </td>
            </tr>
            <tr>
                <td>
                    <div #header1 class="containerHeader container" [ngClass]="showMenu ? 'showMenu':''"
                        style="border-top: 10px solid rgb(206,50,46)">
                        <ul class="navbar-nav" [ngClass]="showMenu ? 'menu-backcolor':''" style="padding: 10px;">
                            <li class="nav-item menuItem"><a href="https://volcanicparadisegalapagos.com/site/"
                                    target="_blank">HOME</a>
                            </li>
                            <li class="nav-item menuItem"><a href="https://volcanicparadisegalapagos.com/site/about-us/"
                                    target="_blank">ABOUT US</a></li>
                            <li class="nav-item menuItem"><a href="https://volcanicparadisegalapagos.com/site/cruises/"
                                    target="_blank">CRUISES</a></li>
                            <li class="nav-item menuItem"><a
                                    href="https://volcanicparadisegalapagos.com/site/land-based-trips/"
                                    target="_blank">LAND BASED TRIPS</a></li>
                            <li class="nav-item menuItem"><a
                                    href="https://volcanicparadisegalapagos.com/site/day-trips/" target="_blank">DAY
                                    TRIPS</a>
                            </li>
                            <li class="nav-item menuItem"><a href="https://volcanicparadisegalapagos.com/site/diving/"
                                    target="_blank">DIVING</a>
                            </li>
                            <li class="nav-item menuItem"><a href="https://volcanicparadisegalapagos.com/site/hotels/"
                                    target="_blank">HOTELS</a>
                            <li class="nav-item menuItem"><a
                                    href="https://volcanicparadisegalapagos.com/site/contact-us/"
                                    target="_blank">CONTACT
                                    US</a>
                        </ul>
                        <div *ngIf="companyParamsService.getFiltersInterest()" class="wishlist tooltip-container">
                            <app-heart-header></app-heart-header>
                        </div>
                    </div>
                </td>
            </tr>
        </table>
    </div>
</nav>